import SpringConfigs from 'utils/constants/swarm/spring-configs';

export type DateFormat = {
  date: string;
  separator?: string;
  time?: string;
  dateTimeSeparator?: string;
  includeWeekday?: boolean;
  weekdaySeparator?: string;
};

const defaultParams: DateFormat = {
  date: '',
  separator: ' ',
  includeWeekday: false,
  weekdaySeparator: ''
};

export const dateFormat = (props: DateFormat): string => {
  const {
    date,
    separator,
    time,
    dateTimeSeparator,
    includeWeekday,
    weekdaySeparator
  } = {
    ...defaultParams,
    ...props
  } as Required<DateFormat>;

  const finalDate = date.replace(/ /g, separator);

  return `${
    includeWeekday && !SpringConfigs.USE_CA_USA_DATE_FORMATTING
      ? `ddd${weekdaySeparator} `
      : ''
  }${finalDate}${time && dateTimeSeparator ? dateTimeSeparator + time : ''}`;
};
